import {Component, ViewChild} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {WorkflowStep} from "../workflow-step";
import {AssetService} from "../../asset/asset.service";
import {AssetSelectionComponent} from "../../asset-select/asset-selection.component";
import {WorkflowTargetInfoModel} from "../models/workflow-target-info.model";
import {WorkflowStepStatus} from "../models/workflow-step-status.enum";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {toggleLoading} from "../../misc/loading.decorator";
import {DeploymentGqlModel} from "../../deployment/deployment.gql-model";
import {DeploymentService} from "../../deployment/deployment.service";

@Component({
  templateUrl: "./pick-asset-deploy.template.pug",
  providers: [AssetService],
})
export class PickAssetsDeployComponent extends WorkflowStep {
  @ViewChild(AssetSelectionComponent)
  private assetPickerChild: AssetSelectionComponent;

  private isReady: boolean = false;

  deploymentId: string = "";
  deployment: DeploymentGqlModel = new DeploymentGqlModel({});

  selectedAssets: string[] = [];
  selectedAccessories: string[] = [];

  error: Error;

  assetSelected(event: Event): void {
    this.selectedAssets = event["assetIds"];
    this.selectedAccessories = event["accessoryIds"];
  }

  setDirty() {
    this.dirty = true;
  }

  @handleErrors()
  async autoSave(): Promise<boolean> {
    await this.assetService.updateAssetsForDeployment(this.deploymentId, this.selectedAssets, this.selectedAccessories);

    await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);

    this.assetPickerChild.refresh();

    return true;
  }

  @toggleLoading()
  @handleErrors()
  async loadData(): Promise<void> {
    this.deployment = await this.deploymentService.getDeploymentById(this.workflowService.workflowConfig.targetId);
  }

  async ready(workflowTargetInfo: WorkflowTargetInfoModel): Promise<void> {
    this.isReady = true;
    this.deploymentId = workflowTargetInfo.targetId;

    if (!this.isLocked && (this.selectedAssets.length || this.selectedAccessories.length)) {
      await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);
    }
    this.loadData();
  }

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    public assetService: AssetService,
    private deploymentService: DeploymentService,
  ) {
    super(true);
  }
}
